'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.utilXmlToJsonService', []);

_module.factory('XmlToJsonService', XmlToJsonService);

exports.default = _module;


function XmlToJsonService() {
    var service = {
        convert: convert
    };

    return service;

    function convert(xml) {
        if (typeof xml === 'string') {
            xml = new window.DOMParser().parseFromString(xml, 'text/xml');
        }
        // Create the return object
        var obj = {};

        // cdata section
        if (4 === xml.nodeType) {
            obj = xml.nodeValue;
        }

        if (xml.hasChildNodes()) {
            for (var i = 0; i < xml.childNodes.length; i++) {
                var TEXT_NODE_TYPE_NAME = '#text';
                var item = xml.childNodes.item(i);
                var nodeName = item.nodeName;
                var content = void 0;

                if (TEXT_NODE_TYPE_NAME === nodeName) {
                    //single textNode or next sibling has a different name
                    if (null === xml.nextSibling || xml.localName !== xml.nextSibling.localName) {
                        content = xml.textContent;

                        //we have a sibling with the same name
                    } else if (xml.localName === xml.nextSibling.localName) {
                        //if it is the first node of its parents childNodes, send it back as an array
                        content = xml.parentElement.childNodes[0] === xml ? [xml.textContent] : xml.textContent;
                    }
                    return content;
                } else {
                    if ('undefined' === typeof obj[nodeName]) {
                        obj[nodeName] = convert(item);
                    } else {
                        if ('undefined' === typeof obj[nodeName].push) {
                            var old = obj[nodeName];
                            obj[nodeName] = [];
                            obj[nodeName].push(old);
                        }

                        obj[nodeName].push(convert(item));
                    }
                }
            }
        }

        if ((0, _isEmpty3.default)(obj)) {
            return null;
        }

        return obj;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/util/xml-to-json.service.js
// module id = 834
// module chunks = 0